import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { api } from '../api/client';
import type { CityDetail as CityDetailType } from '../types/api';

const CityDetail: React.FC = () => {
  const { cityId } = useParams<{ cityId: string }>();
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [city, setCity] = useState<CityDetailType | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!cityId) return;
    api.cities.get(cityId, token)
      .then(setCity)
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load'))
      .finally(() => setLoading(false));
  }, [cityId, token]);

  if (loading) return <div style={{ padding: '24px', color: '#9ca3af' }}>Loading…</div>;
  if (error) return <div style={{ padding: '24px', color: '#dc2626' }}>{error}</div>;
  if (!city) return null;

  const s = city.score;
  return (
    <div style={{ padding: '24px', maxWidth: '700px', margin: '0 auto' }}>
      <Link to="/cities" style={{ color: '#4ade80', textDecoration: 'none', marginBottom: '16px', display: 'inline-block' }}>← Cities</Link>
      <h1 style={{ color: '#fff', marginBottom: '8px' }}>{city.name}</h1>
      <p style={{ color: '#9ca3af', marginBottom: '24px' }}>{city.region}, {city.country}</p>
      {s && (
        <div style={{ padding: '16px', border: '1px solid #374151', borderRadius: '8px', marginBottom: '24px' }}>
          <h2 style={{ color: '#fff', fontSize: '1rem', marginBottom: '12px' }}>Score</h2>
          <p style={{ color: '#9ca3af' }}>Total: {s.totalScore} · Cost: {s.costOfLiving} · Internet: {s.internetSpeed} · Safety: {s.safety}</p>
        </div>
      )}
      <p style={{ color: '#6b7280', fontSize: '14px' }}>Find a TimeStay here — coming soon.</p>
    </div>
  );
};

export default CityDetail;
